export const getLinkTarget = (dataObject = { target: '' }) => {
    const { target, openLinkInSeparateWindow } = dataObject;
    const targetOnOpenLink = openLinkInSeparateWindow ? '_blank' : '_self';

    return dataObject.hasOwnProperty('openLinkInSeparateWindow') ? targetOnOpenLink : target;
};
